import listActions from 'src/modules/userAffirmationProgram/list/userAffirmationProgramListActions';
import UserAffirmationProgramService from 'src/modules/userAffirmationProgram/userAffirmationProgramService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'USERAFFIRMATIONPROGRAM_DESTROY';

const userAffirmationProgramDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: userAffirmationProgramDestroyActions.DESTROY_STARTED,
      });

      await UserAffirmationProgramService.destroyAll([id]);

      dispatch({
        type: userAffirmationProgramDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.userAffirmationProgram.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/user-affirmation-program');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: userAffirmationProgramDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: userAffirmationProgramDestroyActions.DESTROY_ALL_STARTED,
      });

      await UserAffirmationProgramService.destroyAll(ids);

      dispatch({
        type: userAffirmationProgramDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.userAffirmationProgram.destroyAll.success'),
      );

      getHistory().push('/user-affirmation-program');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: userAffirmationProgramDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default userAffirmationProgramDestroyActions;
